var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',{attrs:{"title":"Ponto da rota","titleIcon":"fas fa-map-marker-alt"}},[_c('form-ponto',{attrs:{"paramId":_vm.id},on:{"onSubmitPonto":_vm.afterSubmit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }